import { CONSENT_MODAL_BUTTON_TYPE } from "./constants";
import log from "../../utils/logger/library";
import { isServer } from "../environmentDetection/library";
import {
    ALLOW_PERSONALIZED_CONTENT_DEFAULT,
    DIDOMI_PERSONALIZED_CONTENT_ID,
    DIDOMI_VENDOR_ID,
} from "../../constants/userPreferences";

export function isConsentModalButtonType(type) {
    return type === CONSENT_MODAL_BUTTON_TYPE;
}
export const showPrivacyPreferences = () => {
    try {
        window.Didomi.preferences.show();
    } catch (error) {
        log.error(
            `(showPrivacyPreferences)`,
            new Error(`Failed to show the privacy preferences modal:${error}`)
        );
    }
};

/**
 * Retrieve Didomi personalized content preference from Didomi SDK
 *
 * @return {boolean} allow personalized content preference
 */
export const isPersonalizedContentEnabled = () => {
    let personalizedEnabled, CBCVendorEnabled;

    if (isServer()) {
        return ALLOW_PERSONALIZED_CONTENT_DEFAULT;
    }

    window.CBCCMPQueue = window.CBCCMPQueue || [];
    window.CBCCMPQueue.push((CMPProviders, CBCCMPSettings) => {
        if (CBCCMPSettings.cmpEnabled) {
            const Didomi = CMPProviders?.didomi;
            const userStatus = Didomi?.getCurrentUserStatus() || {};

            // Is personalized content enabled in the Didomi CMP
            personalizedEnabled =
                userStatus?.purposes?.[DIDOMI_PERSONALIZED_CONTENT_ID]?.enabled;
            // Is CBC vendor enabled in the Didomi CMP
            CBCVendorEnabled = userStatus?.vendors?.[DIDOMI_VENDOR_ID]?.enabled;
        }
    });

    const isPersonalizedDefined = typeof personalizedEnabled === "boolean";
    const isCBCVendorDefined = typeof CBCVendorEnabled === "boolean";

    if (isPersonalizedDefined && isCBCVendorDefined) {
        // If both variables are defined, return the combined value
        return personalizedEnabled && CBCVendorEnabled;
    } else if (isPersonalizedDefined) {
        // Return only personalizedEnabled if defined
        return personalizedEnabled;
    } else if (isCBCVendorDefined) {
        // Return only CBCVendorEnabled if defined
        return CBCVendorEnabled;
    }

    // If both variables are undefined, return the default value
    return ALLOW_PERSONALIZED_CONTENT_DEFAULT;
};

export const isCMPVisible = () => {
    if (isServer()) {
        return false;
    }
    let isVisible = false;
    window.CBCCMPQueue = window.CBCCMPQueue || [];
    window.CBCCMPQueue.push((CMPProviders, CBCCMPSettings) => {
        if (CBCCMPSettings.cmpEnabled && CBCCMPSettings.cmpScriptWillBeLoaded) {
            const visible = CMPProviders?.didomi?.notice.isVisible();
            if (visible) isVisible = true;
        }
    });
    return isVisible;
};
